<template>
  <v-layout :v-if="displayRequestModalEditRejectStatus">
    <v-edit-dialog
      @save="onClickSave"
      @cancel="onClickCancel"
      large
      save-text="却下"
      cancel-text="キャンセル"
    >
      <v-btn
        v-if="isWaitingStatus"
        @click="onClick"
        color="red"
        style="width: 60px"
        small
        outline
      >
        却下
      </v-btn>
      <template v-slot:input>
        却下理由
        <v-textarea
          @update:error="updatedValidationFlag($event)"
          v-model="inputRejectReason"
          :rules="rules"
          single-line
          autofocus
          outline
          rows="3"
          background-color="gray"
          hide-details
          style="width: 500px;"
        />
      </template>
    </v-edit-dialog>
  </v-layout>
</template>

<script>
import { MapReportStatuses } from '@/models/MapReport'

const validationMessage = '却下理由は1~50文字以内にしてください。'

export default {
  name: 'AdminMapReportListButtonReject',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: null,
    },
    status: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputRejectReason: '',
      displayRequestModalEditRejectStatus: false,
      isValidError: true,
    }
  },
  computed: {
    isWaitingStatus() {
      return this.status === MapReportStatuses.Waiting
    },
    rules() {
      return [v => (v.length > 0 && v.length <= 50) || validationMessage]
    },
  },
  methods: {
    updatedValidationFlag(isValidError) {
      this.isValidError = isValidError
    },
    onClick() {
      this.displayRequestModalEditRejectStatus = true
    },
    async onClickSave() {
      if (this.isValidError) {
        const result = await this.$confirm(validationMessage, {
          okText: '閉じる',
          onlyOk: true,
        })
        if (result) return
      }
      try {
        this.$emit('updateRejectStatus', this.id, this.inputRejectReason)
      } catch (e) {
        console.error(e)
        throw new Error('却下に失敗しました。')
      }
    },
    onClickCancel() {
      this.displayRequestModalEditRejectStatus = false
    },
  },
}
</script>

<style scoped></style>
